import { useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getLayerColorMaps, getLayerData, getLayerFromGroup } from "../singleLayer/singleLayerService";
import { SingleLayerDeckGL } from "../singleLayer/SingleLayerDeckGL";
import { ReactCompareSlider } from "react-compare-slider";
import { SingleLayerSettings } from "../singleLayer/SingleLayerSettings";
import { SingleLayerCommand } from "../singleLayer/SingleLayerCommand";
import { SingleLayerTitle } from "../singleLayer/SingleLayerTitle";
import { LoadingTail } from "../core/LoadingTail";
import { SplitViewSettings } from "../splitView/SplitViewSettings";
import { SplitViewEmpty } from "../splitView/splitViewEmpty";
import { SplitViewLayerTitle } from "../splitView/SplitViewLayerTitle";

export function LayerBox() {
    let { id, idSplit } = useParams();
    const [idTwo, setIdTwo] = useState(undefined)
    const initViewState = {
        longitude: 105.64,
        latitude: -1.48,
        zoom: 4.6,
        pitch: 0,
        maxZoom: 17,
        minZoom: 4.6,
        bearing: 0
    }
    const [viewState, setViewState] = useState(initViewState);
    const [data, setData] = useState(undefined);
    const [dataTwo, setDataTwo] = useState(undefined);
    const [isView3d, setIsView3d] = useState(false)
    const [isTime, setIsTime] = useState(false)
    const [dataTime, setDataTime] = useState([])
    const [timeSelectedIdx, setTimeSelectedIdx] = useState(0)
    const [isTimeTwo, setIsTimeTwo] = useState(false)
    const [dataTimeTwo, setDataTimeTwo] = useState([])
    const [timeTwoSelectedIdx, setTimeTwoSelectedIdx] = useState(0)
    const [isSplitView, setIsSplitView] = useState(false)
    const [mapTheme, setMapTheme] = useState('basic-v2/{z}/{x}/{y}@2x.png')
    const [mapTwoTheme, setMapTwoTheme] = useState('basic-v2/{z}/{x}/{y}@2x.png')
    const [colorMaps, setColorMaps] = useState([])
    const [colorMapsTwo, setColorMapsTwo] = useState([])
    const [colorMapName, setColorMapName] = useState(undefined)
    const [colorMapTwoName, setColorMapTwoName] = useState(undefined)
    const [colorMapOpacity, setColorMapOpacity] = useState(100)
    const [colorMapTwoOpacity, setColorMapTwoOpacity] = useState(100)

    useEffect(() => {

        if (idSplit) {
            setIsSplitView(true)
            setIdTwo(idSplit)
        }

        getLayerData(id).then(async (response) => {
            if (response) {
                let { data } = response
                if (data['is_time'] === true) {
                    setIsTime(true)
                    setTimeSelectedIdx(0)
                    //console.log(data)
                    const response = await getLayerFromGroup(data['geoserver_workspace'], data['geoserver_layer_name'])
                    //console.log(response)
                    setDataTime(response)
                    // console.log('hey i am layername: '+response[0]['layerName'])
                    data['geoserver_layer_name'] = response[0]['layerName']
                    //console.log(response[0]['layerName'])
                } else {
                    setTimeSelectedIdx(0)
                    setIsTime(false)
                    setDataTime([])
                }

                setData(data)
                //console.log(data)

                if (data['is_raster'] === true) {
                    const response = await getLayerColorMaps(data['geoserver_workspace'], data['geoserver_layer_name'])

                    setColorMaps(response);

                    setColorMapName(data['color_map_default'])
                } else {
                    //setColorMapName('blues')
                }
            }
        })

    }, [id, idSplit]);

    useEffect(() => {
        dataTime && dataTime[timeSelectedIdx] && setData({
            ...data,
            geoserver_layer_name: dataTime[timeSelectedIdx]['layerName']
        })
    }, [timeSelectedIdx])

    useEffect(() => {
        dataTimeTwo && dataTimeTwo[timeTwoSelectedIdx] && setDataTwo({
            ...dataTwo,
            geoserver_layer_name: dataTimeTwo[timeTwoSelectedIdx]['layerName']
        })
    }, [timeTwoSelectedIdx])

    useEffect(() => {
        idTwo && getLayerData(idTwo).then(async (response) => {
            let { data } = response

            if (data['is_time'] === true) {
                setIsTimeTwo(true)
                setTimeTwoSelectedIdx(0)

                const response = await getLayerFromGroup(data['geoserver_workspace'], data['geoserver_layer_name'])
                setDataTimeTwo(response)

                data['geoserver_layer_name'] = response[0]['layerName']
            } else {
                setTimeTwoSelectedIdx(0)
                setIsTimeTwo(false)
                setDataTimeTwo([])
            }

            setDataTwo(response.data)

            if (data['is_raster'] === true) {
                const response = await getLayerColorMaps(data['geoserver_workspace'], data['geoserver_layer_name'])

                setColorMapsTwo(response);

                setColorMapTwoName(data['color_map_default'])
            } else {
                setColorMapTwoName('blues')
            }
        })

    }, [idTwo]);

    return (<>
        {!isSplitView && <SingleLayerDeckGL
            data={data}
            viewState={viewState}
            setViewState={setViewState}
            initViewState={initViewState}
            isView3d={isView3d}
            mapTheme={mapTheme}
            colorMapName={colorMapName}
            colorMapOpacity={colorMapOpacity}
        ></SingleLayerDeckGL>}

        {isSplitView && <ReactCompareSlider
            onlyHandleDraggable={true}
            style={{ height: '100%' }}
            itemOne={<SingleLayerDeckGL
                id={id}
                data={data}
                viewState={viewState}
                setViewState={setViewState}
                isView3d={isView3d}
                mapTheme={mapTheme}
                colorMapName={colorMapName}
                colorMapOpacity={colorMapOpacity}
            ></SingleLayerDeckGL>}

            itemTwo={
                !dataTwo
                    ? <SplitViewEmpty></SplitViewEmpty>
                    : <SingleLayerDeckGL
                        id={idTwo}
                        data={dataTwo}
                        viewState={viewState}
                        setViewState={setViewState}
                        isView3d={isView3d}
                        mapTheme={mapTwoTheme}
                        colorMapName={colorMapTwoName}
                        colorMapOpacity={colorMapTwoOpacity}
                    ></SingleLayerDeckGL>}
        />}

        {!isSplitView && <SingleLayerSettings
            data={data}
            mapTheme={mapTheme}
            setMapTheme={setMapTheme}
            colorMaps={colorMaps}
            colorMapName={colorMapName}
            setColorMapName={setColorMapName}
            colorMapOpacity={colorMapOpacity}
            setColorMapOpacity={setColorMapOpacity}
            viewState={viewState}
            setViewState={setViewState}
        ></SingleLayerSettings>}

        {isSplitView && <SplitViewSettings
            idOne={id}
            idTwo={idTwo}
            setIdTwo={setIdTwo}
            dataOne={data}
            dataTwo={dataTwo}
            mapOneTheme={mapTheme}
            setMapOneTheme={setMapTheme}
            mapTwoTheme={mapTwoTheme}
            setMapTwoTheme={setMapTwoTheme}
            colorMaps={colorMaps}
            colorMapOneName={colorMapName}
            setColorMapOneName={setColorMapName}
            colorMapOneOpacity={colorMapOpacity}
            setColorMapOneOpacity={setColorMapOpacity}
            colorMapsTwo={colorMapsTwo}
            colorMapTwoName={colorMapTwoName}
            setColorMapTwoName={setColorMapTwoName}
            colorMapTwoOpacity={colorMapTwoOpacity}
            setColorMapTwoOpacity={setColorMapTwoOpacity}
            data={data}
            viewState={viewState}
            setViewState={setViewState}
        ></SplitViewSettings>}

        <SingleLayerCommand
            id={id}
            idTwo={idTwo}
            viewState={viewState}
            setViewState={setViewState}
            isView3d={isView3d}
            setIsView3d={setIsView3d}
            isSplitView={isSplitView}
            setIsSplitView={setIsSplitView}
            isTime={isTime}
            dataTime={dataTime}
            timeSelectedIdx={timeSelectedIdx}
            setTimeSelectedIdx={setTimeSelectedIdx}
            isTimeTwo={isTimeTwo}
            dataTimeTwo={dataTimeTwo}
            timeTwoSelectedIdx={timeTwoSelectedIdx}
            setTimeTwoSelectedIdx={setTimeTwoSelectedIdx}
        ></SingleLayerCommand>

        {!isSplitView && <SingleLayerTitle
            id={id}
        ></SingleLayerTitle>}

        {isSplitView && <SplitViewLayerTitle
            idOne={id}
            idTwo={idTwo}
        ></SplitViewLayerTitle>}

        <LoadingTail />
    </>)

}